import { useRefreshCoilStore } from '@/coils/stores/refreshCoilStore';
import { useFeatureFlagStore } from '@/featureFlags/stores/featureFlagStore';
import { useRefreshPackageStore } from '@/packages/commands/refreshPackageStore';
import { useRefreshProductionOrderStore } from '@/productionOrders/stores/refreshProductionOrderStore';
import { useRefereshProductStore } from '@/products/commands/refreshProductStore';
import { useRefereshProductGroupStore } from '@/products/groups/commands/refreshProductGroupStore';
import { useRefreshSettingStore } from '@/settings/stores/refreshSettingStore';
import { useRefreshShapeStore } from '@/shapes/stores/refreshShapeStore';
import { useRefreshStorageAreaStore } from '@/storageAreas/stores/refreshStorageAreaStore';
import { useRefreshVehicleStore } from '@/vehicles/stores/refreshVehicleStore';

export function useRefreshState() {
  const featureFlags = useFeatureFlagStore();

  const refreshProductStore = useRefereshProductStore();
  const refreshSettingStore = useRefreshSettingStore();
  const refreshShapeStore = useRefreshShapeStore();
  const refreshStorageAreaStore = useRefreshStorageAreaStore();
  const refreshVehicleStore = useRefreshVehicleStore();
  const refreshCoilStore = useRefreshCoilStore();
  const refreshProductionOrderStore = useRefreshProductionOrderStore();
  const refreshPackageStore = useRefreshPackageStore();
  const refreshProductGroupStore = useRefereshProductGroupStore();

  async function initialize() {
    refreshProductStore.initialize();
    refreshShapeStore.initialize();
    refreshSettingStore.initialize();
    refreshStorageAreaStore.initialize();
    refreshVehicleStore.initialize();
    refreshProductionOrderStore.initialize();
    refreshProductGroupStore.initialize();

    if (featureFlags.isCoilEnabled()) {
      refreshCoilStore.initialize();
    }

    if (featureFlags.isPackagesEnabled()) {
      refreshPackageStore.initialize();
    }
  }

  async function refresh() {
    await Promise.all([
      refreshProductStore.refresh(),
      refreshShapeStore.refresh(),
      refreshSettingStore.refresh(),
      refreshStorageAreaStore.refresh(),
      refreshVehicleStore.refresh(),
      refreshProductionOrderStore.refresh(),
      refreshProductGroupStore.refresh(),
      ...(featureFlags.isCoilEnabled() ? [refreshCoilStore.refresh()] : []),
      ...(featureFlags.isPackagesEnabled() ? [refreshPackageStore.refresh()] : []),
    ]);
  }

  return {
    initialize,
    refresh,
  };
}
